import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { authenticateUser } from '../../actions/util/authenticationJwtActions'
import ModalEsqueciMinhaSenha from './ModalEsqueciMinhaSenha';
import ModalEsqueciMinhaSenhaMobile from './ModalEsqueciMinhaSenhaMobile'
import ReCaptchaV2 from 'react-google-recaptcha'
import { AUTHENTICATION_FAILED } from '../../actions/types';
import imgColunaEsq from '../../img/coluna-sistema.jpg';
import imgLogoBranca from '../../img/logo-branco-01.png';
import CarouselBlog from '../layout/CarouselBlog';
import BotaoIrParaBaixo from '../BotaoIrParaBaixo';
import BotaoVoltarAoTopo from '../BotaoVoltarAoTopo';

const renderField = (field) => {
  const { meta: { touched, error } } = field;
  const className = `form-group ${touched && error ? 'text-danger-login' : ''}`;

  return (
    <div className={className}>
      <label className='login-nm'>{field.label}</label>
      <input className="form-control"
        id={field.id}
        style={{ textTransform: 'lowercase' }}
        type={field.type}
        placeholder={field.placeholder}
        {...field.input}
        autoFocus={field.input.name === 'username'} />
      <div>
        {touched ? error : ''}
      </div>
    </div>
  )
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chaveCaptcha: null
    }
    this.recaptchaRef = React.createRef();
    this.recaptchaRefMobile = React.createRef();
  }

  changeRecaptcha(value) {
    if (value) {
      this.setState({ chaveCaptcha: value })
    }
  }

  onSubmit(values) {
    this.props.authenticateUser({
      username: values.username.toLowerCase()
        .trim(),
      password: values.password,
      chaveCaptcha: this.state.chaveCaptcha
    })
      .then((resp) => {
        if (resp.type === AUTHENTICATION_FAILED) {
          this.setState({ chaveCaptcha: null })
          this.recaptchaRef.current.reset();
          this.recaptchaRefMobile.current.reset();
        }
      })
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { isAuthenticated } = this.props.authentication;

    if (isAuthenticated) {
      return (<Redirect to={from} />)
    }

    const { handleSubmit } = this.props;

    return (
      <div className='page-login'>
        <div id='inicioPag' className="row desktop">
          <div className="col-md-6">
            <img src={imgColunaEsq} className='img-lateral' alt="sistema vexado" />
          </div>
          <div className="col-md-6">
            <form className="container form-login" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className='mb-4'>
                <p className="head-login">Fazer login</p>
              </div>
              <div className='loginHeader'>
                {/* <img src={logo} alt='Vexado'/> */}
              </div>
              <label htmlFor='username'>Usuário:</label>
              <Field
                ref={(input) => {
                  this.campoUsuario = input
                }}
                name='username'
                type='text'
                id='username'
                placeholder=''
                component={renderField}
              />
              <label htmlFor='password'>Senha:</label>
              <Field
                name='password'
                id='password'
                type='password'
                placeholder=''
                component={renderField}
              />
              <span className='float-right login-nm' data-toggle="modal" data-target="#modalEsqueciMinhaSenha" style={{ cursor: 'pointer' }}>
                Esqueci minha senha
              </span>
              <button id='btn-entrar' type='submit' className='btn btn-laranja' disabled={!this.state.chaveCaptcha}>ENTRAR</button>
              <div className='col-12 text-center'>
                <ReCaptchaV2
                  ref={this.recaptchaRef}
                  style={{ display: 'inline-block' }}
                  sitekey={'6LfNrvkdAAAAAL2wVMaGIuOwJ0STFzIOavTKhNvw'}
                  onChange={(value) => this.changeRecaptcha(value)}
                  onExpired={() => this.setState({ chaveCaptcha: null })}
                  onErrored={() => this.setState({ chaveCaptcha: null })} />
              </div>
            </form>
            <ModalEsqueciMinhaSenha />
          </div>
          <div className='container-baixo'>
            <div className='container-button'>
              <BotaoIrParaBaixo />
            </div>
            <div className='container-blogs'>
              <CarouselBlog />
            </div>
            <div className='container-button'>
              <BotaoVoltarAoTopo />
            </div>
          </div>
        </div>

        <div className='row mobile'>
          <div className='col-md-12'>
            <form className="container form-login" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className='mb-4' style={{ textAlign: 'center' }}>
                <img src={imgLogoBranca} className='img-logo-branca' alt='Vexado' />
                <p className="head-login">Fazer login</p>
              </div>
              <div className='loginHeader'>
                {/* <img src={logo} alt='Vexado'/> */}
              </div>
              <label htmlFor='username1'>Usuário:</label>
              <Field
                ref={(input) => {
                  this.campoUsuario = input
                }}
                name='username'
                type='text'
                id='username'
                placeholder=''
                component={renderField}
              />
              <label htmlFor='password1'>Senha:</label>
              <Field
                name='password'
                id='password'
                type='password'
                placeholder=''
                component={renderField}
              />
              <span className='float-right' data-toggle="modal" data-target="#modalEsqueciMinhaSenhaMobile" style={{ cursor: 'pointer' }}>
                Esqueci minha senha
              </span>
              <button id='btn-entrar' type='submit' className='btn btn-laranja' disabled={!this.state.chaveCaptcha}>ENTRAR</button>
              <div className='col-12 text-center'>
                <ReCaptchaV2
                  ref={this.recaptchaRefMobile}
                  style={{ display: 'inline-block' }}
                  sitekey={'6LfNrvkdAAAAAL2wVMaGIuOwJ0STFzIOavTKhNvw'}
                  onChange={(value) => this.changeRecaptcha(value)}
                  onExpired={() => this.setState({ chaveCaptcha: null })}
                  onErrored={() => this.setState({ chaveCaptcha: null })} />
              </div>
            </form>
            <div className='container-blogs'>
              <CarouselBlog />
            </div>
            <ModalEsqueciMinhaSenhaMobile />
          </div>
        </div>
      </div>

    )
  }
}

function validate(values) {
  const errors = {};

  if (!values.username) {
    errors.username = 'Por favor, informe o usuário'
  }

  if (!values.password) {
    errors.password = 'Por favor, informe a senha'
  }

  return errors
}

const mapStateToProps = ({ authentication }) => ({ authentication });

const reduxConnectEnhance = connect(mapStateToProps, { authenticateUser })(Login);

export default reduxForm({
  validate,
  form: 'LoginForm'
})(reduxConnectEnhance)
